import { AbstractReportPmsApiService } from '../abstract-report.service';
import { DailyRevenue } from "../../../models/reports/daily-activity/daily-revenue.model";

/**
 * @class DailyRevenuePmsApiService
 * @extends {AbstractReportPmsApiService<DailyRevenue>}
 */
export class DailyRevenuePmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/daily-revenue';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {DailyRevenue}
     * @protected
     */
    newModel(attributes, ...params) {

        return new DailyRevenue(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<DailyRevenue>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/daily-revenue.service.js